import React, { useEffect, useState } from 'react'

import { getDecoratedObjectTimerValue } from 'helpers/getDecoratedTimerValue'

import { IFormattedTime } from 'models/common.model'

import { INITIAL_TIMER_VALUES, MINUTES_IN_SECONDS } from 'root-constants'

interface ITimerForTarget extends IFormattedTime {
  isExpired: boolean
}

export const useTimerForTarget = (
  timerElementRef: React.RefObject<HTMLElement>,
  startTimeValueInSeconds: number,
): ITimerForTarget => {
  const initialTimerValues =
    startTimeValueInSeconds === MINUTES_IN_SECONDS.TEN
      ? INITIAL_TIMER_VALUES.TEN_MINUTES
      : getDecoratedObjectTimerValue(startTimeValueInSeconds)

  const [formattedTime, setFormattedTime] =
    useState<IFormattedTime>(initialTimerValues)
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    let intervalID: ReturnType<typeof setInterval>

    const handleExpired = () => {
      clearInterval(intervalID)
      setIsExpired(true)
    }

    const setIntervalCallback = () => {
      if (!timerElementRef?.current) return

      const timerElement = timerElementRef.current
      const currentTimerValue = +(
        timerElement.dataset.value || startTimeValueInSeconds
      )

      if (currentTimerValue <= 0) {
        setFormattedTime(getDecoratedObjectTimerValue(0))
        handleExpired()
        return
      }

      const nextTimerValue = currentTimerValue - 1

      timerElement.setAttribute('data-value', `${nextTimerValue}`)
      setFormattedTime(getDecoratedObjectTimerValue(nextTimerValue))

      if (nextTimerValue <= 0) handleExpired()
    }

    intervalID = setInterval(setIntervalCallback, 1000)

    return () => {
      clearInterval(intervalID)
    }
  }, [startTimeValueInSeconds, timerElementRef])

  return { ...formattedTime, isExpired }
}
